import React, { useState, useContext, useEffect } from 'react';
import { TextField, Button, Box, Typography, Paper, Alert } from '@mui/material';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';

// Custom SVG illustration for teachers/reading
const TeacherBookSVG = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 12 }}>
    <rect x="8" y="16" width="64" height="48" rx="12" fill="#E0F7FA" stroke="#4FC3F7" strokeWidth="2"/>
    <rect x="16" y="24" width="48" height="32" rx="6" fill="#FFFDE7" stroke="#81C784" strokeWidth="2"/>
    <path d="M24 32C28 36 36 36 40 32C44 36 52 36 56 32" stroke="#4FC3F7" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="28" cy="40" r="2" fill="#81C784"/>
    <circle cx="52" cy="40" r="2" fill="#81C784"/>
    <rect x="34" y="44" width="12" height="4" rx="2" fill="#FFD54F"/>
  </svg>
);

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login, teacher } = useContext(AuthContext);

  useEffect(() => {
    if (teacher) navigate('/dashboard');
  }, [teacher, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    console.log('🔐 Frontend login attempt:', { email, password: password ? '[PROVIDED]' : '[MISSING]' });
    
    try {
      console.log('📡 Making API request to /api/auth/login...');
      const res = await api.post('/api/auth/login', { email, password });
      console.log('✅ Login response:', res.data);
      
      localStorage.setItem('token', res.data.token);
      console.log('💾 Token saved to localStorage');
      
      login(res.data.teacher);
      console.log('👤 Teacher logged in:', res.data.teacher);
      
      navigate('/dashboard');
    } catch (err) {
      console.error('💥 Frontend login error:', err);
      console.error('Error response:', err.response?.data);
      console.error('Error status:', err.response?.status);
      setError(err.response?.data?.error || err.response?.data?.details || err.message || 'Login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa 0%, #fffde7 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Nunito, sans-serif',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          minWidth: 350,
          borderRadius: 4,
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          textAlign: 'center',
          background: '#f9fafc',
        }}
      >
        <TeacherBookSVG />
        <Typography variant="h4" mb={1} fontWeight={700} fontFamily="Nunito, sans-serif">
          Welcome, Teacher!
        </Typography>
        <Typography variant="subtitle1" mb={3} color="text.secondary">
          Log in to help your students shine ✨
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            sx={{ borderRadius: 2, background: '#fff' }}
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            sx={{ borderRadius: 2, background: '#fff' }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              borderRadius: 2,
              fontWeight: 'bold',
              fontSize: '1.1rem',
              background: 'linear-gradient(90deg, #4fc3f7 0%, #81c784 100%)',
              color: '#fff',
              boxShadow: '0 2px 8px rgba(79,195,247,0.15)',
              '&:hover': {
                background: 'linear-gradient(90deg, #81c784 0%, #4fc3f7 100%)',
              },
            }}
          >
            Log In
          </Button>
        </form>
        <Button
          onClick={() => navigate('/register')}
          sx={{
            mt: 2,
            color: '#4fc3f7',
            fontWeight: 'bold',
            borderRadius: 2,
            textTransform: 'none',
          }}
          fullWidth
        >
          New here? Register
        </Button>
      </Paper>
    </Box>
  );
} 